@if (this.navigationList) {
@for (breadcrumb of navigationList; track breadcrumb; let last = $last) {
@if (last && breadcrumb.breadcrumbs !== false) {
<div class="page-header">
  <div class="page-block">
    <div class="row align-items-center">
      <div class="col-md-12">
        <div class="page-header-title d-flex align-items-center justify-content-between">
          <div class="left-side">
            @for (breadcrumb of navigationList; track breadcrumb; let last = $last) {
            @if (last) {
            <h5 class="m-0">{{ breadcrumb.title }}</h5>
            }
            }
          </div>
          <div class="right-side">
            <ul class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <a [routerLink]="['/dashboard/analytics/']" title="Home"><i class="feather icon-home"></i></a>
              </li>
              @for (breadcrumb of navigationList; track breadcrumb) {
              @if (breadcrumb.url !== false) {
              <li class="breadcrumb-item"><a [routerLink]="breadcrumb.url">{{ breadcrumb.title }}</a></li>
              }
              @if (breadcrumb.url === false && breadcrumb.type !== 'group') {
              <li class="breadcrumb-item"><a href="javascript:">{{ breadcrumb.title }}</a></li>
              }
              }
            </ul>
          </div>
        </div>
        <!-- <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <a [routerLink]="['/dashboard/analytics/']" title="Home"><i class="feather icon-home"></i></a>
          </li>
          @for (breadcrumb of navigationList; track breadcrumb) {
          @if (breadcrumb.url !== false) {
          <li class="breadcrumb-item"><a [routerLink]="breadcrumb.url">{{ breadcrumb.title }}</a></li>
          }
          @if (breadcrumb.url === false && breadcrumb.type !== 'group') {
          <li class="breadcrumb-item"><a href="javascript:">{{ breadcrumb.title }}</a></li>
          }
          }
        </ul> -->
      </div>
    </div>
  </div>
</div>
}
}
}